"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const StringArrayEncoding_1 = require("../../enums/StringArrayEncoding");
exports.StringArrayEncodingSanitizer = (value) => {
    switch (value) {
        case 'true':
        case '1':
        case StringArrayEncoding_1.StringArrayEncoding.Base64:
            return true;
        case StringArrayEncoding_1.StringArrayEncoding.Rc4:
            return StringArrayEncoding_1.StringArrayEncoding.Rc4;
        default:
            return false;
    }
};
